import { RouteConfig } from 'vue-router';

import Confirm from '@/views/Confirm.vue';

export const confirmRoute: RouteConfig = {
  path: '/confirm/:token',
  name: 'confirm',
  component: Confirm
};
